import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import axios from 'axios';
import LayoutAdminHeader from '../components/LayoutAdminHeader';
import LayoutAdminFooter from '../components/LayoutAdminFooter';

const BASE_URL = process.env.REACT_APP_BASE_URL || '';

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filteredOrders, setFilteredOrders] = useState([]);

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

const res = await axios.get(`${BASE_URL}/Order/GetAllOrders`, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});
      const data = res.data.data || [];
      console.log(data);
      setOrders(data);
      setFilteredOrders(data);
    } catch (err) {
      console.error('Error fetching orders', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearch(value);
    const filtered = orders.filter(order =>
      order.GstNumber?.toLowerCase().includes(value) ||
      order.FinancialYear?.toLowerCase().includes(value)
    );
    setFilteredOrders(filtered);
  };

  const columns = [
    {
      field: 'OrderId',
      headerName: 'Order ID',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'GstNumber',
      headerName: 'GST Number',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'FinancialYear',
      headerName: 'Financial Year',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'OrderAmount',
      headerName: 'Amount (₹)',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'Discount',
      headerName: 'Discount (%)',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'FinalAmount',
      headerName: 'Final Amount (₹)',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
    },
  ];

  return (
    <>
      <LayoutAdminHeader />
      <Box p={2}>
        <Typography variant="h5" gutterBottom>
          Order List
        </Typography>

        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <TextField
            label="Search by GST or Year"
            variant="outlined"
            value={search}
            onChange={handleSearch}
            fullWidth
          />
        </Box>

        <DataGrid
          autoHeight
          rows={filteredOrders.map((order, index) => ({ ...order, id: index }))}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[5, 10, 20]}
          loading={loading}
          disableSelectionOnClick
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f0f0f0',
              fontWeight: 'bold',
              fontSize: '16px',
            },
            '& .MuiDataGrid-cell': {
              fontSize: '14px',
            },
            '& .MuiDataGrid-row:hover': {
              backgroundColor: '#fafafa',
            },
          }}
        />
      </Box>
      <br/>
       <br/>
        <br/>
         <br/>
          <br/>
           <br/>
            <br/>
             <br/>
              <br/>
               <br/>
                <br/>
                 <br/>
                  <br/>
                   <br/>
                    <br/>
                     <br/>
                      <br/>
                       <br/>
                         <br/>
                        <br/>
      {/* <LayoutAdminFooter /> */}
    </>
  );
};

export default OrderList;
